"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleApolloClientMutation = exports.handleApolloClientQuery = void 0;
const apolloClient_1 = __importDefault(require("./apolloClient"));
async function handleApolloClientQuery(options, api, linkOptions) {
    return await (0, apolloClient_1.default)(api, linkOptions).query(options);
}
exports.handleApolloClientQuery = handleApolloClientQuery;
async function handleApolloClientMutation(options, api, linkOptions) {
    return await (0, apolloClient_1.default)(api).mutate(options);
}
exports.handleApolloClientMutation = handleApolloClientMutation;
//# sourceMappingURL=handleApolloClientRequest.js.map